import React from "react";
import { IonPage, IonContent } from "@ionic/react";
const PrivacyPolicy = () => {
  return (
    <>
      <div style={{ padding: "5px 10px", fontSize: ".8rem", color: "black" }}>
        <h3>Privacy Policy</h3>
        <ol>
          <li>
            <b>Introduction</b>
            <br />
            <ol>
              <li>
                We respect your privacy rights and recognize the importance of
                secure transactions and information privacy. This Privacy Policy
                describes how iDigizen collect, use, share or otherwise process
                your personal information through VypZee application.
              </li>
              <li>
                By visiting VypZee, providing your information or availing our
                product/service, you expressly agree to be bound by the terms of
                this Privacy Policy and the applicable Terms of service. While
                accessing or using our platform/services, you have given
                explicit consent to collect, use, share or otherwise process
                your information in accordance with this Privacy Policy. If you
                do not agree, please do not access or use our Platform or
                service.
              </li>
              <li>
                You acknowledge that you are disclosing Personal Information
                voluntarily. Prior to the completion of any registration process
                on our platform or prior to availing of any services offered on
                our platform if you wish not to disclose any Personal
                Information you may refrain from doing so; however if you don't
                provide information that is requested, it is possible that the
                registration process would be incomplete and/or you would not be
                able to avail of the our services. If you are our corporate
                customer, it is possible that we have entered into a contract
                with you for non-disclosure of confidential information. This
                Policy shall not affect such a contract in any manner.
              </li>
            </ol>
          </li>
          <li>
            <b>Application of policy</b>
            <br />
            This policy applies to all contractors, suppliers, customers, users,
            vendors, sellers, partners, and other third party working on behalf
            of iDigizen or accessing or using our platforms/service.
          </li>
          <li>
            <b>Objectives of policy</b>
            <br />
            iDigizen is required to collect & use certain information about
            individuals, i.e., customers, suppliers/vendors, business contacts,
            employees, and the third parties with whom iDigizem has a business
            relationship or may need to contact. This policy describes, how
            iDigizen collects, receives, possesses, stores, deals or handle
            personal information including sensitive personal information about
            you and ensure that the same are available for review by you. The
            personal information must be collected, handled and stored to meet
            the data protection standards as well as legislative requirements.
            This policy ensures to comply with data protection law and follows
            the good practice and protects the rights of employees, customers,
            suppliers/vendors, business contacts, employees, and the third
            parties and how to stores and processes data and protects from the
            risks of data breach.
          </li>
          <li>
            <b>Collection of information</b>
            <br />
            <ol>
              <li>
                In the course of carrying out its various functions and
                activities, iDigizen collects information from individuals &
                third parties and generates a wide range of information which is
                stored at our platform.
              </li>
              <li>
                We collect Personal Information from you in a variety of ways
                when you interact with us through our services, such as,
                installing, accessing, or using our Services; Create an account
                on our services or interact with merchants using iDigizen’s
                application.
              </li>
              <li>
                In the course of registering for and availing various services
                we provide from time to time through VypZee application in which
                iDigizen may provide you may be required to give your name,
                residence address, email address, phone number, and similar
                Personal Information ("Personal Information").
              </li>
            </ol>
          </li>
          <li>
            <b>Usage of Information</b>
            <br />
            <ol>
              <li>To provide services.</li>
              <li>To help us personalize our service offerings</li>
              <li>For operation and maintenance purposes</li>
              <li>
                It helps us in operating, providing, improving, understanding,
                customizing, supporting, and marketing our Services
              </li>
              <li>
                Personal Information will be kept confidential and will be used
                for our research, marketing, and strategic client analysis
                objectives and other internal business purposes only. We do not
                sell Personal Information.
              </li>
              <li>
                Personal information while transacting with specific merchants
                on the VypZee platform for loyalty, coupon download and other
                such services will be shared with the specific merchants for
                which you transacted for.
              </li>
              <li>
                We do not use your mobile phone number or other Personally
                Identifiable Information to send commercial or marketing
                messages without your consent or except as part of a specific
                program or feature for which you will have the ability to opt-in
                or opt-out. We may use cookies and log file information to (a)
                remember information so that you will not have to re-enter it
                during your re-visit on our platform; (b) provide custom,
                personalized content and information; (c) monitoring or pages
                viewed, etc.; and (d) track your entries, submissions, views
                etc.,.
              </li>
            </ol>
          </li>
          <li>
            <b>Protection of Personal Information:</b>
            <br />
            <ol>
              <li>
                We are committed to protecting the privacy of your personal
                information. While we do not sell, share, or lease your personal
                information to third parties for marketing or promotional
                purposes without your explicit consent, please note that if you
                voluntarily provide your personal information to a specific
                third-party business through our platform, you may be subject to
                their privacy policies and practices.
              </li>
              <li>
                By engaging with a third-party business on our platform and
                providing them with your personal information, you consent to
                their use of your information for marketing and promotional
                purposes in accordance with their privacy policies.
              </li>
              <li>
                iDigizen cannot guarantee or control the use of your personal
                information by third-party businesses. If you have any concerns
                about the use of your personal information by a third-party
                business, please contact them directly to address your concerns.
                iDigizen cannot be held liable for how the 3rd party uses your
                personal information.
              </li>
            </ol>
          </li>
          <li>
            <b>Grievance Officer</b>
            <br />
            In accordance with Information Technology Act 2000 and rules &
            regulations made thereunder, the name and contact details of the
            Grievance Officer are provided below:
            <br />
            <br />
            Mr. Jishnu De
            <br />
            Address: E-251-A, Shushant Lok Phase 1, Sector 51-A, Gurugram,
            Haryana
            <br />
            Email: info@idigizen.com
            <br />
            Contact: 8448338565
          </li>
        </ol>
      </div>
    </>
  );
};

export default PrivacyPolicy;
